module.exports = __webpack_public_path__ + "img/32646.7c155b38.png";